import styled from "styled-components";

export const TournamentStateNoticeWrapper = styled.div`
  margin: 20px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  > .header {
    font-weight: 700;
    font-size: 20px;
  }
`;

export const TournamentStateNoticeBack = styled.div<{ more: boolean }>`
  background: var(--Black-100, #f0f0f0);
  width: 100%;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  gap: 16px;
  align-items: flex-start;
  justify-content: space-between;

  > .content {
    font-weight: 400;
    font-size: 13px;
    ${(p) =>
      p.more
        ? ""
        : `
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    `}
  }
`;
